import { IServiceFamily } from "@/model/ServiceFamily/ServiceFamily"
import AccomodationServiceFamily from "@/model/ServiceFamily/AccomodationServiceFamily"
import GlobalServiceFamily from "@/model/ServiceFamily/GlobalServiceFamily"
import ParticipantServiceFamily from "@/model/ServiceFamily/ParticipantServiceFamily"
import EquipmentServiceFamily from "@/model/ServiceFamily/EquipmentServiceFamily"
import SkiSchoolServiceFamily from "@/model/ServiceFamily/SkiSchoolServiceFamily"
import FoodServiceFamily from "@/model/ServiceFamily/FoodServiceFamily"
import ParkingServiceFamily from "@/model/ServiceFamily/ParkingServiceFamily"
import SkipassServiceFamily from "@/model/ServiceFamily/SkipassServiceFamily"
import TransportServiceFamily from "@/model/ServiceFamily/TransportServiceFamily"
import RestaurationServiceFamily from "@/model/ServiceFamily/RestaurationServiceFamily"
import HoteliersServiceFamily from "@/model/ServiceFamily/HoteliersServiceFamily"
import ServiceFamilyContent from "@/model/Content/ServiceFamilyContent"

import ServiceTypeEnum from "@/config/serviceTypeEnum"

import {ServiceFamilyContent as ServiceFamilyContentDTO} from "@requests"

export interface IServiceFamilyFactory {

}


class ServiceFamilyFactory implements IServiceFamilyFactory {


    public static getServiceFamily(familyId: string, type: string) {
        if (['3', '75'].includes(familyId)) return new SkipassServiceFamily(familyId)
        if (['4'].includes(familyId)) return new HoteliersServiceFamily(familyId)
        if (['5'].includes(familyId)) return new FoodServiceFamily(familyId)
        if (['8'].includes(familyId)) return new TransportServiceFamily(familyId)
        if (['11'].includes(familyId)) return new RestaurationServiceFamily(familyId)
        if (['12'].includes(familyId)) return new SkiSchoolServiceFamily(familyId)
        if (['53', '54', '55', '56','57','63'].includes(familyId)) return new EquipmentServiceFamily(familyId)
        if (['64'].includes(familyId)) return new SkiSchoolServiceFamily(familyId)
        if (['69'].includes(familyId)) return new ParkingServiceFamily(familyId)
        if (['78'].includes(familyId)) return new TransportServiceFamily(familyId)
        if (type === ServiceTypeEnum.Participant) return new ParticipantServiceFamily(familyId)
        if (type === ServiceTypeEnum.Accomodation) return new AccomodationServiceFamily(familyId)
        if (type === ServiceTypeEnum.Global) return new GlobalServiceFamily(familyId)
        throw new Error(`no service family exists for type: ${type}`)
    }


    public static createServiceFamily(familyId: string, contentObj: ServiceFamilyContentDTO, familyType: string): IServiceFamily {
        const serviceFamily: IServiceFamily = ServiceFamilyFactory.getServiceFamily(familyId, familyType)
        const serviceFamilyContent = new ServiceFamilyContent(contentObj?.name, contentObj?.description, contentObj?.image, contentObj?.type)

        serviceFamily.setServiceFamilyContent(serviceFamilyContent)
        serviceFamilyContent.setServiceFamily(serviceFamily)

        return serviceFamily
    }
}

export default ServiceFamilyFactory